import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon, EditPencilIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextDestructive, colorTextSecondary, colorTextStandard, colorTextWarning } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { InviteeActions } from './invitee_actions';
import { InviteeAvatar } from './invitee_avatar';
import { NoShowButton } from './no_show_button';
import { getPaymentSubtitleText } from './payment_utils';
import { Heading, NameString } from './styles';
const detailsToggleCss = "d171g3zj";
const DetailsToggle = ({
  isOpen,
  onClick
}) => <BareButton onClick={e => {
  e.stopPropagation();
  onClick();
}} className={detailsToggleCss} aria-label={isOpen ? I18n.t('publisher.meetings.invitees.hide_details') : I18n.t('publisher.meetings.invitees.show_details')}>
    <BodyText color={colorTextStandard} size="small">
      {I18n.t('publisher.meetings.tabs.details')}
    </BodyText>
    {isOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
  </BareButton>;
const minimalButtonCss = "mfronh9";
const MinimalButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(minimalButtonCss, props.className)} />);
const noShowButtonContainerCss = "n1knd1c3";
const NoShowButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(noShowButtonContainerCss, props.className)} />;
});
const emailButtonContainerCss = "et5aw8u";
const EmailButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emailButtonContainerCss, props.className)} />;
});
const displayNameCss = "d1clzjup";
const DisplayName = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(displayNameCss, props.className)} />;
});
export const AvatarDropdown = ({
  displayName,
  isCancelled,
  isRescheduled,
  isConfirmed,
  isGuest,
  contact,
  onHeadingClick,
  openEditEmailModal,
  nameButtonRef,
  isGroup,
  turnOnNoShowClicked,
  canEditEmail,
  canMarkNoShow,
  event,
  invitee,
  toggle,
  isOpen,
  canReschedule = false,
  canCancel = false,
  canBlock = false,
  canUnblock = false,
  shouldShowMenu = false,
  isLegacy = false
}) => {
  const {
    charge,
    blockedByHost
  } = invitee;
  const hasCharge = charge && charge.captured;
  const showCharge = isGroup && !isLegacy && hasCharge;
  const questionsCount = (invitee.eventFields?.length ?? 0) + (invitee.formBuilderSubmission?.questions?.length ?? 0);
  const paymentSubtitleText = showCharge && charge ? getPaymentSubtitleText(charge) : null;
  return <>
      <InviteeAvatar displayName={displayName} isCancelled={isCancelled} isRescheduled={isRescheduled} isConfirmed={isConfirmed} tooltip />
      <Heading isGuest={isGuest} isContact={Boolean(contact)}>
        <NameString strike={isCancelled || isRescheduled || blockedByHost}>
          <DisplayName><FullStoryMask>{displayName}</FullStoryMask></DisplayName>
        </NameString>
        {isGroup && isRescheduled && <BodyText size="x-small" color={colorTextWarning} weight="semibold">
            {I18n.t('publisher.meetings.header_badge.rescheduled')}
          </BodyText>}
        {isGroup && isCancelled && !isRescheduled && <BodyText size="x-small" color={colorTextDestructive} weight="semibold">
            {I18n.t('publisher.meetings.header_badge.canceled')}
          </BodyText>}
        {isGroup && !isRescheduled && !isCancelled && (questionsCount > 0 || showCharge) && <BodyText size="x-small" color={colorTextSecondary}>
            {questionsCount > 0 && showCharge && <>
                {I18n.t('publisher.meetings.invitees.questions_answered_count', {
            count: questionsCount
          })}
                {' • '}
                {paymentSubtitleText}
              </>}
            {questionsCount > 0 && !showCharge && I18n.t('publisher.meetings.invitees.questions_answered_count', {
          count: questionsCount
        })}
            {!questionsCount && showCharge && paymentSubtitleText}
          </BodyText>}
        {isGuest && <BodyText size="x-small" color={colorTextSecondary}>{I18n.t('publisher.meetings.invitees.guest_label')}</BodyText>}
        {blockedByHost && <BodyText size="x-small" color={colorTextSecondary}>{I18n.t('publisher.meetings.invitees.blocked')}</BodyText>}
        {!isGroup && canEditEmail && !shouldShowMenu && <EmailButtonContainer>
            <MinimalButton onClick={openEditEmailModal}>
              <EditPencilIcon />
              <BodyText size="x-small">
                {I18n.t('publisher.meetings.invitees.edit_invitee_email')}
              </BodyText>
            </MinimalButton>
          </EmailButtonContainer>}
      </Heading>
      {!isGroup && canMarkNoShow && !blockedByHost && <NoShowButtonContainer>
          <NoShowButton event={event} invitee={invitee} onMarkAsNoShow={turnOnNoShowClicked} />
        </NoShowButtonContainer>}
      {!isGroup && shouldShowMenu && <InviteeActions event={event} invitee={invitee} canReschedule={canReschedule} canCancel={canCancel} canBlock={canBlock} canUnblock={canUnblock} openEditEmailModal={openEditEmailModal} canEditEmail={canEditEmail} />}
      {isGroup && <DetailsToggle isOpen={isOpen} onClick={toggle} />}
    </>;
};

require("./avatar_dropdown.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./avatar_dropdown.js");